import React, { useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUploadCloud, FiRefreshCw, FiImage } = FiIcons;

export default function PhotoUpload({ photoName, onUpload }) {
  const inputRef = useRef(null);
  return (
    <section className="panel">
      <div className="section-heading">
        <div className="section-icon"><SafeIcon icon={FiUploadCloud} /></div>
        <div><span className="eyebrow">PASUL 02</span><h2>Imaginea ta</h2></div>
      </div>
      <p className="section-description">Încarcă fotografia pentru postare. Banda sponsorilor va fi adăugată ca o continuare a imaginii.</p>
      <input ref={inputRef} className="visually-hidden" type="file" accept="image/png,image/jpeg,image/webp" onChange={event => { onUpload(event.target.files?.[0]); event.target.value = ''; }} />
      <button className={`upload-zone ${photoName ? 'has-photo' : ''}`} type="button" onClick={() => inputRef.current?.click()}>
        <span className="upload-symbol"><SafeIcon icon={photoName ? FiImage : FiUploadCloud} /></span>
        <strong>{photoName || 'Alege o imagine'}</strong>
        <span>{photoName ? 'Apasă pentru a schimba imaginea' : 'PNG, JPG sau WEBP · rezoluția originală este păstrată'}</span>
        <span className="upload-cta"><SafeIcon icon={photoName ? FiRefreshCw : FiUploadCloud} /> {photoName ? 'Schimbă imaginea' : 'Încarcă imagine'}</span>
      </button>
    </section>
  );
}